/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext, useState } from "react";
import { CaptivePortalContext, CreateLoginPageContext } from "../../../context/ContextProvider";
import { Input, Label } from "reactstrap";
import ModalImageManager from "./ModalImageManager";
import LayoutFormButton from "./LayoutFormButton";

const defaultImageName = "None";

const LayoutImageForm = ({config, onContentChange, type = "logo", noNone = false }) => {
  // global context
  const captivePortalContext = useContext(CaptivePortalContext);
  const createLoginPageContext = useContext(CreateLoginPageContext);
  const imageList = captivePortalContext.imageList.filter(image => type == null || image.type === type);
  const clientId = createLoginPageContext.clientScope;

  // image upload modal state
  const [showImageUpload, setShowImageUpload] = useState(false);

  // handlers
  const handleUploaded = (newImage) => {
    onContentChange(newImage.url);
  };

  // styles
  const sizeStyle = { maxHeight: "100px", maxWidth: "180px" };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="flex-static" style={sizeStyle}>
        {config ? (
          <img src={config} alt="Error displaying content" style={{ ...sizeStyle, borderRadius: "10px" }} />
        ) : (
          <div className="fill-container d-flex justify-content-center image-placeholder">
            <Label className="m-2 w-100 text-center">No image selected</Label>
          </div>
        )}
      </div>
      <Input
        className="ms-2"
        type="select"
        disabled={imageList ? false : true}
        onChange={(event) => onContentChange(event.target.value === defaultImageName ? null : event.target.value)}
        value={config}
      >
        {!noNone && <option className="text-muted" value="">{defaultImageName}</option>}
        {imageList && imageList.map((image, index) => (
          <option key={index} value={image.url}>{image.name}</option>
        ))}
      </Input>
      <LayoutFormButton className="ms-2" outline icon="cloud-upload" onClick={() => setShowImageUpload(true)} />
      <ModalImageManager
        isOpen={showImageUpload}
        onUploaded={handleUploaded}
        onClose={() => setShowImageUpload(false)}
        scope={clientId}
        type={type}
      />
    </div>
  );
};

export default LayoutImageForm;
